import script from "./insights-sidepane-toggle.vue?vue&type=script&setup=true&lang=ts"
export * from "./insights-sidepane-toggle.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__